export default "__VITE_ASSET__Btd3Mk6p__"